import { LabelWithActions } from "~/screens/Admins/components/LabelWithActions";
import { dateToUsFormat } from "~/shared/utils";
import { icons } from "~/ui";

type Props = {
  scheduleAvailable: boolean;
  fileName?: string;
  lastModified?: string;
  canEdit: boolean;
  canDownloadLog: boolean;
  onEdit: () => void;
  onExport: () => void;
  onDelete: () => void;
  onDownloadLog: () => void;
};

export const ProviderScheduleSection = ({
  scheduleAvailable,
  fileName,
  lastModified,
  canEdit,
  canDownloadLog,
  onEdit,
  onExport,
  onDelete,
  onDownloadLog,
}: Props) => {
  const actions = canEdit
    ? [
        {
          onClick: onExport,
          Icon: icons.outline.ArrowDownTrayIcon,
          label: "Export schedule",
        },
        {
          onClick: onEdit,
          Icon: icons.outline.PencilIcon,
          label: "Edit schedule",
        },
        {
          onClick: onDelete,
          Icon: icons.outline.TrashIcon,
          label: "Delete schedule",
        },
      ]
    : [];

  return (
    <div className="flex w-full items-center justify-between">
      <div className="flex w-full flex-col gap-3">
        <p className="text-indigo">Schedule</p>

        {scheduleAvailable ? (
          <div>
            <LabelWithActions
              value={
                <span className="truncate text-neutral-800">{fileName}</span>
              }
              actions={actions.map(({ onClick, Icon, label }) => (
                <button
                  key={label}
                  type="button"
                  onClick={onClick}
                  aria-label={label}
                >
                  <Icon className="text-indigo size-5 cursor-pointer" />
                </button>
              ))}
            />

            {lastModified && (
              <p className="mt-2 text-sm text-neutral-600">
                Last Modified Date (ET): {dateToUsFormat(lastModified)}
              </p>
            )}
          </div>
        ) : (
          <p className="text-neutral-600">No active schedule template</p>
        )}

        {canDownloadLog && (
          <button
            type="button"
            onClick={onDownloadLog}
            className="text-indigo flex cursor-pointer gap-2"
            aria-label="Download schedule change log"
          >
            Download schedule change log
            <icons.outline.ArrowDownTrayIcon className="size-5 font-medium" />
          </button>
        )}
      </div>

      {!scheduleAvailable && canEdit && (
        <button type="button" onClick={onEdit} aria-label="Edit schedule">
          <icons.outline.PencilIcon className="text-indigo size-5 cursor-pointer" />
        </button>
      )}
    </div>
  );
};
